import { render, staticRenderFns } from "./EntityUpdater.vue?vue&type=template&id=5846d027&"
import script from "./EntityUpdater.vue?vue&type=script&lang=js&"
export * from "./EntityUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports